import CryptoJS from "crypto-js";
import { PAYMENT_APIKEY, PAYMENT_SECRET } from "../../utils";

// CryptoJS ашиглан HMAC-SHA256-ийг hex болгож гаргана
function hmacSha256Hex(secret, message) {
  return CryptoJS.HmacSHA256(message, secret).toString(CryptoJS.enc.Hex);
}

// Payment request-д шаардлагатай гарын үсэг бүхий header-үүдийг бэлдэнэ
const signPaymentHeaders = ({ url, method, bodyStr }) => {
  const path = new URL(url).pathname;
  const timestamp = Math.floor(Date.now() / 1000).toString();
  const canonical = `${method.toUpperCase()}\n${path}\n${timestamp}\n${
    bodyStr || ""
  }`;
  const signature = hmacSha256Hex(PAYMENT_SECRET, canonical);

  return {
    "X-API-KEY": PAYMENT_APIKEY,
    "X-TIMESTAMP": timestamp,
    "X-SIGNATURE": signature,
  };
};

export const _request = async ({
  url,
  method,
  body,
  isfile,
  isservice,
  type,
}) => {
  const token = localStorage.getItem("access_token");
  const errorSms = {
    message: "Алдаа",
    success: false,
    data: [],
  };
  let Authorization = "Bearer " + token;
  const ispayment = type === "payment";

  if (method === "GET") {
    let headers = {
      Accept: "application/json, text/plain, */*",
      "Content-Type": "application/json",
      Authorization: Authorization,
    };
    if (ispayment)
      headers = {
        ...headers,
        ...signPaymentHeaders({ url, method, bodyStr: "" }),
      };

    return fetch(url, {
      method: "GET",
      /*  mode: "no-cors", */
      headers,
    })
      .then((res) => {
        if (res.status === 200) return res.json();
        else return res;
      })
      .catch((error) => {
        errorSms.message = error.message;
        return errorSms;
      });
  }

  if (isfile) {
    const request = new Request(url, {
      method,
      headers: new Headers({ Authorization: Authorization }),
      body,
    });
    return fetch(request)
      .then((res) => {
        if (res.status === 200) return res.json();
        else return res;
      })
      .catch((error) => {
        errorSms.message = error.message;
        return errorSms;
      });
  }

  const bodyStr = JSON.stringify(body);
  let headers;
  if (type === "car") {
    // smartcar XYP API нь Authorization авдаггүй, тусдаа header шаарддаг
    headers = {
      Accept: "*/*",
      "Accept-Language": "mn",
      "Content-Type": "application/json",
      Os: "web",
      Version: "3.2.0",
    };
  } else {
    headers = {
      "Content-Type": "application/json",
      Authorization: Authorization,
    };
    if (ispayment)
      headers = {
        ...headers,
        ...signPaymentHeaders({ url, method, bodyStr }),
      };
  }

  return fetch(url, {
    method,
    headers,
    body: bodyStr,
  })
    .then((res) => {
      if (res.status === 200) return res.json();
      else return res;
    })
    .catch((error) => {
      if (error.message.includes("Failed to fetch") && isservice)
        errorSms.message = "Service тэй холбогдож чадсангүй.";
      else errorSms.message = error.message;

      return errorSms;
    });
};

const fetchRequest = async ({
  body,
  url,
  method,
  model,
  dispatchEvent,
  notification,
  isfile,
  isservice,
  type,
}) => {
  try {
    if (model) dispatchEvent({ type: model.request });

    let res = await _request({ url, method, body, isfile, isservice, type });

    if (url?.includes("system/weather")) {
      if (res?.success && res?.data) res.data = JSON.parse(res?.data);
    }
    /* !res.success && notification({ type: "warning", message: res.message });
            
            if (res.success) {
              model.response.includes('update') && notification({ type: "success", message: res.message });
              model.response.includes("create") &&
                notification({ type: "success", message: res.message });
            } */

    if (model) dispatchEvent({ type: model.response, response: res });

    return res;
  } catch (error) {
    return dispatchEvent({
      type: model.error,
      error: error,
    });
  }
};

export { fetchRequest };
